import { ChurnRiskLevel } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/shared/enums.pb';

/**
 * Extracts the last word from a ChurnRiskLevel enum value.
 * For example:
 * - CHURN_RISK_LEVEL_LOW -> "low"
 * - CHURN_RISK_LEVEL_MEDIUM -> "medium"
 * - CHURN_RISK_LEVEL_HIGH -> "high"
 * - CHURN_RISK_LEVEL_UNSPECIFIED -> "unspecified"
 *
 * @param churnRiskLevel - The ChurnRiskLevel enum value
 * @returns The last word of the enum in lowercase
 */
export const getChurnRiskLevelLabel = (churnRiskLevel: ChurnRiskLevel): string => {
  const parts = churnRiskLevel.split('_');
  return parts[parts.length - 1].toUpperCase();
};
